<script>
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';

export default {
  data() {
    return {
      id: 0,
      isDefault: false,
      selectedCompanyId: this.companyId,
    };
  },
  props: {
    rushInfo: {
      type: Object,
      required: true,
    },
    companyOptions: {
      type: Array,
      default: () => [],
    },
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  mixins: [toggleModal],
  mounted() {
    this.isDefault = this.rushInfo.isDefault;
    this.selectedCompanyId = this.rushInfo.companyId ?? null;
  },
  methods: {
    ...mapActions({
      changeRushAction: 'rushes/changeRush',
    }),
    handleOk(values) {
      this.changeRushAction({
        ...values,
        id: this.rushInfo.id,
        isDefault: this.isDefault,
        companyId: this.selectedCompanyId ?? null,
      });
      this.hideModal();
    },
  },
};
</script>

<template>
  <div>
    <a-modal :open="show" :footer="null" @cancel="hideModal">
      <FormKit
        type="form"
        submit-label="Edit rush"
        @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">Edit rush</h1>
        <FormKit
          type="number"
          number="integer"
          name="percent"
          label="Percentage"
          placeholder="Percentage"
          validation="required"
          :value="rushInfo.percent"
        />
        <div class="toggle">
          Default can rush
          <a-switch class="mb-2" v-model:checked="isDefault" ></a-switch>
        </div>
        <a-form-item label="Company" class="mb-2" v-if="!Boolean(companyId)">
          <a-select
            v-model:value="selectedCompanyId"
            :options="companyOptions"
            allow-clear
            placeholder="Select company"
            style="width: 100%"
          />
        </a-form-item>
        <FormKit
          type="text"
          name="digitize"
          label="Digitize text"
          placeholder="Digitize text"
          validation="required"
          :value="rushInfo.digitize"
        />
        <FormKit
          type="text"
          name="enhance"
          label="Enhance text"
          placeholder="Enhance text"
          validation="required"
          :value="rushInfo.enhance"
        />
        <FormKit
          type="text"
          name="photoArt"
          label="Photo art text"
          placeholder="Photo art text"
          validation="required"
          :value="rushInfo.photoArt"
        />
      </FormKit>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">
.toggle {
  margin: 20px 0;
}
</style>
